module.exports = __webpack_public_path__ + "media/images/character-img-walking-7f397b11c491e9ab6134ee07567b03df.png";